// @flow
import moment from 'moment';

import { DOCUMENT_TYPES_TITLES_SHORT, TOKEN } from './Constants';
import i18n from './i18n';

export const getDocumentTypeTitleShort = (title: string): string => {
  let useableTitle = title.replace(/\W/g, '');
  return DOCUMENT_TYPES_TITLES_SHORT[useableTitle];
};

export const setAuthToken = (token: string) => {
  localStorage.setItem(TOKEN, token);
};

export const getAuthToken = () => {
  return localStorage.getItem(TOKEN);
};

export const removeAuthToken = () => {
  return localStorage.removeItem(TOKEN);
};

/**
 * FORMATS DATE TO SPECIFIED FORAMT VIA MOMENT
 * @param  {String} date                      Date from backend api response
 * @param  {String} [formatType='default' }]  return format for date, specifed in i18n file
 * @return {String}                           Formatted Date String
 */
export const dateFormatTo = (date: Date, formatType: string = 'default') => {
  if (!date) return '';
  return moment(date).format(i18n.dateFormats[formatType]);
};

/**
 * PARSES SEARCH PARAMS FROM URL AND RETURNS A STATE OBJECT
 * FOR USE IN SucheContextReise or SucheContextDokument
 */
export const paramsToStateMap = {
  'q[text]': 'searchValue',
  'q[catalog_year]': 'selectedCatalogYear',
  'q[voyage_variation]': 'selectedVariation',
  'q[start_date]': 'selectedDate.start_date',
  'q[end_date]': 'selectedDate.end_date',
  'q[customer_text]': 'searchCustomerValue',
  page: 'page'
};

export const parseParamsToState = (params: any) => {
  const parsedSearchParam = JSON.parse(params);
  const state = {};
  Object.entries(parsedSearchParam).map((key, value) => {
    const stateKey = paramsToStateMap[key[0]];
    if (stateKey) {
      state[stateKey] = key[1];
    }
    return true;
  });
  return state;
};

export const reflect = p =>
  p.then(v => ({ v, status: 'fulfilled' }), e => ({ e, status: 'rejected' }));

export const arrayToObject = (array, recursive) =>
  array.reduce((obj, item) => {
    obj[item.id] = item;
    if (recursive) {
      Object.entries(item).map(eObj => {
        if (Array.isArray(eObj[1])) {
          obj[item.id][eObj[0]] = arrayToObject(eObj[1], true);
        }
        return true;
      });
    }
    return obj;
  }, {});

export const camelCaseToUnderscore = myString => {
  return myString
    .split(/(?=[A-Z])/)
    .join('_')
    .toLowerCase();
};

export const searchCallToObjKey = funcName => {
  switch (funcName) {
    case 'voyageDates':
      return 'voyages_dates';
    default:
      return funcName;
  }
};

// a little function to help us with reordering the result
export const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

export const flattenNestedArray = (
  arr: Array<{ fields: Array<Object> }>
): Array<Object> => {
  let flatFields = [];
  arr.map(area => {
    flatFields = [...flatFields, ...area.fields];
    return true;
  });
  return flatFields;
};

export const deepFindObject = (obj, path_orig) => {
  for (var i = 0, path = path_orig.split('.'), len = path.length; i < len; i++) {
    obj = obj ? obj[path[i]] : null;
  }
  return obj;
};

export const createImageResponseObject = images => {
  let imageArray = [];
  images.map(image => {
    if ('public_url' in image) {
      imageArray = [
        ...imageArray,
        {
          public_remote_resource_id: image.id,
          title: image.title
        }
      ];
    } else {
      imageArray = [...imageArray, image];
    }
    return true;
  });
  return imageArray;
};

export const createVideoResponseObject = videos => {
  let videoArray = [];
  videos.map(video => {
    if (video == null) return false;
    if (!('id' in video)) {
      videoArray = [
        ...videoArray,
        {
          youtube_video_key: video.youtube_video_key
        }
      ];
    } else {
      videoArray = [...videoArray, video];
    }
    return true;
  });
  return videoArray;
};

export const getRatingStars = count => {
  const arr = Array.from(Array(Math.floor(Number(count))));
  let starString = '';
  arr.map((_, i) => {
    starString += '*';
    return true;
  });
  if (Number(count) % 1 !== 0) {
    starString += '(*)';
  }
  return starString;
};

export const sortDatesByYearAndMonth = dateArray => {
  let sorted = {};
  dateArray.map(da => {
    sorted = {
      ...sorted,
      ...{
        [da.year]: {
          ...(sorted[da.year] ? sorted[da.year] : {}),
          [da.month]: [
            ...(sorted[da.year]
              ? sorted[da.year][da.month]
                ? sorted[da.year][da.month]
                : []
              : []),
            da
          ]
        }
      }
    };
    return true;
  });
  return sorted;
};



// WEBPACK FOOTER //
// ./src/utils/Helper.js